import { routeChangeEvent } from 'lib/analytics'

export const navigateWithoutScroll = (newPathname: string) => {
  window.history.replaceState(null, '', newPathname)

  routeChangeEvent()
}
